export function getCurrentStage(): 'test'|'prod' {
  const nimbusStage: string = String("${NIMBUS_DEPLOYMENT_STAGE}")
  if (nimbusStage == 'test') {
    return 'test';
  }
  if (nimbusStage == 'prod') {
    return 'prod';
  }
  return 'test';
}

export function isLocalEnvironment(): boolean {
  const nimbusStage: string = String("${NIMBUS_DEPLOYMENT_STAGE}")
  return nimbusStage !== 'test' && nimbusStage !== 'prod';
}

export const TEST_ENVIRONMENT = getCurrentStage() === 'test';
